import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveTipoComprobante } from '../../shared/components';

export type CreateTipoComprobantePageProps = {};

const CreateTipoComprobantePage: React.FC<
  CreateTipoComprobantePageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_add_tipocomprobante);

  return <SaveTipoComprobante title="Crear Tipo de Comprobante" />;
};

export default CreateTipoComprobantePage;
